<template>
  <section class="section" id="courses" style="padding: 50px 0">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div class="container">
      <template v-for="item in blocks">
        <div
          class="row row-eq-height mt-4 align-items-center"
          :key="item.id + 'block'"
          v-if="(item.id = block)"
        >
          <div class="col-lg-3 col-md-3 col-12" v-if="item.id == 4">
            <img
              src="@/assets/full.jpg"
              class="img-fluid rounded-top mx-auto"
              alt
            />
          </div>
          <div class="col-lg-6 col-md-6 col-12" v-if="item.id == 4">
            <div class="c_block mt-md-0 mt-2">
              <div class="c_name">
                Первый онлайн-симулятор, который обучает решать конфликты и
                вести переговоры
              </div>
              <div class="c_description">
                Более 100 часов теории и практики конфликтов и переговоров
              </div>
              <b-form-input
                v-if="!item.paid"
                placeholder="промокод"
                v-model="promocode"
              ></b-form-input>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-12" v-if="item.id == 4">
            <div class="payment_block">
              <div class="value text-md-right text-left" v-if="!item.paid">
                {{ item.price }} ₽
              </div>

              <b-button
                variant="primary float-md-right  mt-1 ml-md-2  mr-2 mr-md-2"
                @click="pay_block(item.id)"
                v-if="!item.paid"
                >Купить</b-button
              >
              <b-button
                variant="success float-md-right mt-sm-0 mt-1"
                :disabled="true"
                v-else
                >Куплено</b-button
              >
              <b-button
                variant="primary float-md-right  mt-1  "
                @click="pay_block_credit(item.id)"
                v-if="!item.paid"
                >В рассрочку</b-button
              >

              <div class="nav_block">
                <div
                  class="pages"
                  v-b-tooltip.hover
                  title="Телеграм чат"
                  @click.stop.prevent="to_tg"
                  v-if="item.paid"
                >
                  <i
                    class="lab la-telegram-plane"
                    style="padding: 13px; font-size: 34px"
                  ></i>
                </div>
                <div
                  class="pages"
                  v-b-tooltip.hover
                  title="Сертификат"
                  @click.stop.prevent="to_cert"
                  v-if="item.paid && is_cert"
                >
                  <i
                    class="las la-certificate"
                    style="padding: 13px; font-size: 34px"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" :key="item.id" v-if="(item.id = block)">
          <div
            class="col-md-10 col-12"
            v-for="(course, index) in item.lession_set"
            :key="course.id"
          >
            <div class="media features pt-4 pb-4">
              <div
                class="icon text-center rounded-circle text-primary mr-3 mt-2"
              >
                <p
                  style="
                    font-size: 20px;
                    padding-top: 10px;
                    font-weight: 800;
                    color: rgb(8, 162, 220);
                  "
                >
                  {{ index + 1 }}
                </p>
              </div>
              <div class="media-body">
                <h4 class="title-2">{{ course.name }}</h4>
                <p class="text-muted mb-0" v-html="course.description">
                  В этой главе мы разберем, как поступать в конфликтной
                  ситуации, на что опираться в своем ответе, как реагировать на
                  всплеск эмоций и защищаться в случае агрессии.
                </p>
                <div
                  class="content-footer"
                  style="cursor: pointer"
                  v-if="
                    course.active &&
                    (item.paid || course.paid || course.price == 0)
                  "
                  @click="open(course)"
                >
                  {{
                    course.complete
                      ? "Завершено"
                      : course.started
                      ? "Продолжить"
                      : "Начать"
                  }}
                </div>
                <div
                  class="content-footer"
                  style="cursor: not-allowed; background-color: grey"
                  v-else-if="
                    course.active &&
                    !item.paid &&
                    !course.paid &&
                    course.price > 0
                  "
                >
                  Нужно купить курс
                </div>
                <div
                  class="content-footer noactive"
                  style="cursor: pointer"
                  v-else
                >
                  Скоро
                </div>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
      </template>
      <!--end row-->
    </div>
    <!--end container-->
  </section>
</template>

<script>
import API from "@/api";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Courses",
  components: { Loading },
  mounted() {
    this.$gtag.pageview({
      page_path: "/cources",
    });
    const user = this.$store.getters.userData;
    if (
      user.first_name == null ||
      user.icon == null ||
      user.icon == "" ||
      user.email == null ||
      user.email == ""
    ) {
      this.$router.push("/makeUser");
    }

    this.isLoading = true;
    this.get_courses();
    this.has_certificate();
  },
  methods: {
    has_certificate() {
      API.get("api/my_certificates/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      })
        .then((response) => {
          if (response.data.length != 0) {
            this.is_cert = true;
          }
        })
        .catch(
          function (error) {
            if (error.response.status == 401) {
              this.$store.dispatch("logout");
            }
          }.bind(this)
        );
    },
    to_tg() {
      window.open("https://t.me/joinchat/BVVanxxaohzXipua5WXuPQ", "_blank");
    },
    to_cert() {
      this.$router.push("/certificate");
    },
    pay_page(id) {
      if (this.promocode != "") {
        const win = window.open("about:blank", "", "height=600,width=400");
        win.document.write("Перенаправляем в платежный сервис...");
        const config1 = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        };
        API.post(
          "/api/activate_promo_code",
          { promo_code: this.promocode, lession: id },
          config1
        )
          .then((response1) => {
            if (response1.data.success) {
              const config = {
                headers: { Authorization: `Bearer ${this.$store.state.token}` },
              };
              const data = new FormData();
              data.append("lession", id);
              data.append("promo_code", this.promocode);
              API.post("api/pay/", data, config).then((response) => {
                win.location.replace(response.data.confirmation_url);
                win.focus();
                this.check_payment(response.data.id, win);
              });
            } else {
              win.close();
              this.$bvToast.toast("Такого промокода нет", {
                title: "Ошибка в промокоде",
                variant: "danger",
                solid: true,
              });
            }
          })
          .catch(
            function (error) {
              win.close();
              this.$bvToast.toast("Такого промокода нет", {
                title: "Ошибка в промокоде",
                variant: "danger",
                solid: true,
              });
            }.bind(this)
          );
      } else {
        const win = window.open("about:blank", "", "height=600,width=auto");
        win.document.write("Перенаправляем в платежный сервис...");
        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        };
        const data = new FormData();
        data.append("lession", id);
        API.post("api/pay/", data, config).then((response) => {
          win.location.replace(response.data.confirmation_url);
          win.focus();
          this.check_payment(response.data.id, win);
        });
      }
    },
    pay_block(id) {
      this.$gtag.event("start", {
        event_category: "payment",
      });
      if (this.promocode != "") {
        const win = window.open("about:blank", "", "height=600,width=auto");
        win.document.write("Перенаправляем в платежный сервис...");
        const config1 = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        };
        API.post(
          "/api/activate_promo_code",
          { promo_code: this.promocode, block: id },
          config1
        )
          .then((response1) => {
            if (response1.data.success) {
              const config = {
                headers: { Authorization: `Bearer ${this.$store.state.token}` },
              };
              const data = new FormData();
              data.append("block", id);
              data.append("promo_code", this.promocode);
              API.post("api/pay/", data, config).then((response) => {
                win.location.replace(response.data.confirmation_url);
                win.focus();
                this.check_payment(response.data.id, win);
              });
            } else {
              win.close();
              this.$bvToast.toast("Такого промокода нет", {
                title: "Ошибка в промокоде",
                variant: "danger",
                solid: true,
              });
            }
          })
          .catch(
            function (error) {
              win.close();
              this.$bvToast.toast("Такого промокода нет", {
                title: "Ошибка в промокоде",
                variant: "danger",
                solid: true,
              });
            }.bind(this)
          );
      } else {
        const win = window.open("about:blank", "", "height=600,width=auto");
        win.document.write("Перенаправляем в платежный сервис...");

        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        };
        const data = new FormData();
        data.append("block", id);
        API.post("api/pay/", data, config).then((response) => {
          win.location.replace(response.data.confirmation_url);
          win.focus();
          this.check_payment(response.data.id, win);
        });
      }
    },
    pay_block_credit(id) {
      this.$gtag.event("start", {
        event_category: "payment",
      });
      if (this.promocode != "") {
        const win = window.open("about:blank", "", "height=600,width=auto");
        win.document.write("Перенаправляем в платежный сервис...");
        const config1 = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        };
        API.post(
          "/api/activate_promo_code",
          { promo_code: this.promocode, block: id },
          config1
        )
          .then((response1) => {
            if (response1.data.success) {
              const config = {
                headers: { Authorization: `Bearer ${this.$store.state.token}` },
              };
              const data = new FormData();
              data.append("block", id);
              data.append("promo_code", this.promocode);
              data.append("tinkoff_promocode", 'installment_0_0_6_6');
              API.post("api/pay/", data, config).then((response) => {
                win.location.replace(response.data.confirmation_url);
                win.focus();
                this.check_payment(response.data.id, win);
              });
            } else {
              win.close();
              this.$bvToast.toast("Такого промокода нет", {
                title: "Ошибка в промокоде",
                variant: "danger",
                solid: true,
              });
            }
          })
          .catch(
            function (error) {
              win.close();
              this.$bvToast.toast("Такого промокода нет", {
                title: "Ошибка в промокоде",
                variant: "danger",
                solid: true,
              });
            }.bind(this)
          );
      } else {
        const win = window.open("about:blank", "", "height=600,width=auto");
        win.document.write("Перенаправляем в платежный сервис...");

        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.token}` },
        };
        const data = new FormData();
        data.append("block", id);
        data.append("tinkoff_promocode", 'installment_0_0_6_6');
        API.post("api/pay/", data, config).then((response) => {
          win.location.replace(response.data.confirmation_url);
          win.focus();
          this.check_payment(response.data.id, win);
        });
      }
    },
    check_payment(id, win) {
      var timer = setInterval(
        function () {
          const config = {
            headers: { Authorization: `Bearer ${this.$store.state.token}` },
          };
          API.get("api/payment/" + id, config).then((response) => {
            if (response.data.status == 0) {
              win.close();
              clearInterval(timer);
            }
            if (response.data.status == 1) {
            }
            if (response.data.status == 2) {
              fbq("track", "Purchase", { currency: "RUB", value: 20.0 });
              this.$gtag.event("success", {
                event_category: "payment",
              });
              win.close();
              this.get_courses();
              clearInterval(timer);
            }
          });
        }.bind(this),
        10000
      );
    },
    get_courses() {
      API.get("api/blocks/", {
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      })
        .then((response) => {
          this.blocks = response.data;
          this.isLoading = false;
        })
        .catch(
          function (error) {
            this.$store.dispatch("logout");
          }.bind(this)
        );
    },
    open(page) {
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` },
      };
      const data = new FormData();
      data.append("page", page.current_page);
      API.post("api/set_current_page/", data, config).then((response) => {
        this.$store.commit("setPage", {
          page: page.current_page,
          onboarding: true,
        });
        this.$router.push({ path: "/" });
      });
    },
  },
  data() {
    return {
      block: 4,
      blocks: [],
      promocode: "",
      isLoading: false,
      is_cert: false,
    };
  },
};
</script>
<style lang="scss" scoped>
@import url(../assets/landing/css/materialdesignicons.min.css);
@import url(../assets/landing/css/style.css);
@import url(../assets/landing/css/colors/default.css);

.nav ul li {
  display: inline;
  margin-right: 10px;
  font-size: 18px;
  border-bottom: 3px #eee solid;
  cursor: pointer;
  transition: all 0.2s ease;
}
.nav ul li.active {
  font-weight: bold;
  border-bottom: 3px #08a2dc solid;
}
.nav ul {
  padding-left: 0;
}
.content-footer {
  color: white;
  background-color: #08a2dc;
  padding: 8px 20px;
  border-radius: 10px;
  float: left;
  text-align: center;
}
.content-footer.noactive {
  background-color: #eee;
  color: black;
  cursor: not-allowed !important;
}

.c_name {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* or 122% */

  color: #000;
}
.c_description {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #777777;
}
.value {
  font-family: "Open Sans", "Nunito", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 44px;
  /* or 176% */

  text-align: center;

  color: #70baff;
}
@media (max-width: 1199px) {
  .pages {
    height: 40px !important;
    width: 40px !important;
  }
  .pages i {
    padding: 10px !important;
    font-size: 20px !important;
  }
}
.pages {
  -webkit-transition: background 0.35s, box-shadow 0.5s, -webkit-transform 0.5s;
  transition: background 0.35s, box-shadow 0.5s, -webkit-transform 0.5s;
  transition: transform 0.5s, background 0.35s, box-shadow 0.5s;
  transition: transform 0.5s, background 0.35s, box-shadow 0.5s,
    -webkit-transform 0.5s;
  box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.15);
  background: #fff;
  color: #08a2dc;
  cursor: pointer;
  font-size: 24px;
  margin-top: 10px;

  height: 60px;
  width: 60px;
  border-radius: 30px;
}
</style>
